import { Component, ChangeDetectionStrategy, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { iconEdit, iconSave } from 'app/common/utils/icons.utils';
import { FileProvider, MediaFileDescription } from 'app/services/FileProvider.service';
import { SecurityService } from 'app/services/security.service';
import { environment } from 'environments/environment';
import { FileItem, FileUploader } from 'ng2-file-upload';


@Component({
	selector: 'base-view-file-component',
	templateUrl: './upload.component.html',
	changeDetection: ChangeDetectionStrategy.Default,
	styleUrls: ['./upload.component.scss']
})
export class FileUploadComponent implements OnInit {

	uploader: FileUploader;
	hasBaseDropZoneOver = false;
	hasAnotherDropZoneOver = false;
	updateEnabled: boolean = false;
	iconEdit = iconEdit;
	iconSave = iconSave;
	@Input() mediaId: number;
	@Input() invalid: boolean;
	@Input() readonly: boolean = false;
	@Input() possibileMediaTypes: any[] = [];
	@Output() onMediaUpdate: EventEmitter<any> = new EventEmitter();
	@ViewChild('fileInputElement') fileInputElement: ElementRef;
	constructor(private _authService: SecurityService, private _fileProvider: FileProvider) {
		
	}
	initFileUploader() {
		if (!this.uploader) {
			this.uploader = new FileUploader({
				authToken: "Bearer " + this._authService.getAccessToken(),
				itemAlias: "file",
				isHTML5: true,
			});
		}
		this.uploader.options.url= environment.services.mediaContentsBasePath;
		this.uploader.options.method=  "POST";
	}
	item;
	currentFile: MediaFileDescription;
	ngOnInit() {
		this.initFileUploader();
		if (this.mediaId) {
			this._fileProvider.getFileInfo(this.mediaId).subscribe(result => {
				this.currentFile = result;
			});
		}
		else {
			this.updateEnabled = true;
		}

		this.uploader.onAfterAddingFile = (item: FileItem) => {
			if (this.updateEnabled) {
				if (this.possibileMediaTypes.length==0 || (this.possibileMediaTypes.length > 0 && this.possibileMediaTypes.indexOf(item.file.type)>=0)) {
					this.item = item;
					item.upload();
				}
			}
		}
		this.uploader.onBeforeUploadItem = (item) => {
			item.withCredentials = false;
		}
		this.uploader.onBuildItemForm = (item: FileItem, form: any) => {
			form.append('filename' , item.file.name);
			if (item.file.type)
				form.append('mimetype' , item.file.type);
			else
				form.append('mimetype' , "application/octet-stream");
		};
	  
		this.uploader.onSuccessItem = (item: FileItem, response: any, status: any, headers: any) => {
			const reader = new FileReader();
			reader.addEventListener("load", () => {
				let result : MediaFileDescription = new MediaFileDescription();
				Object.assign(result,JSON.parse(response));
				result.mediaUrl = reader.result;
				this.currentFile = result;
				this.mediaId = result.id;
				this.updateEnabled = false;
				this.initFileUploader();
				this.onMediaUpdate.emit(result);
			}, false);
			reader.readAsDataURL(item._file);
		}
	}

	fileOverBase(e: any): void {
		this.hasBaseDropZoneOver = e && this.updateEnabled;
	}

	clickOnDropzone($event) {
		this.fileInputElement.nativeElement.click();	
	}
	get iconToShow() {
		return (this.updateEnabled)? this.iconSave: this.iconEdit;
	}
	clickOnshowFile($event: MouseEvent) {
		$event.preventDefault();
		$event.stopPropagation();

		this.updateEnabled = !this.updateEnabled;
	}
}